import { Link } from "react-router-dom";
import "../../../styles/components/Footer.scss";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";

const quickLinks = [
  { to: "/about", label: "About Dr. Ila Gupta" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/gallery", label: "Gallery" },
  { to: "/media", label: "Media" },
  { to: "/blog", label: "Blogs" },
  { to: "/videos", label: "Videos" },
  { to: "/contact", label: "Contact" },
];

const servicesPrimary = [
  { to: "/infertility-treatment-in-delhi", label: "Infertility Counselling" },
  { to: "/artificial-insemination-iui", label: "Artificial Insemination (IUI)" },
  { to: "/ivf-treatment-in-delhi", label: "IVF" },
  { to: "/icsi", label: "ICSI" },
  { to: "/imsi", label: "IMSI" },
  { to: "/assisted-hatching", label: "Assisted Hatching" },
  { to: "/blastocyst-transfer", label: "Blastocyst Transfer" },
  { to: "/donor-egg-ivf", label: "Donor Egg IVF" },
];

const servicesSecondary = [
  { to: "/donor-sperm-ivf", label: "Donor Sperm IVF" },
  { to: "/surrogacy", label: "Surrogacy" },
  { to: "/oocyte-and-embryo-freezing", label: "Oocyte & Embryo Freezing" },
  { to: "/testicular-aspiration-or-tesa", label: "TESA" },
  { to: "/microtesa", label: "Micro TESA" },
  { to: "/pre-genetic-screening-and-diagnosis", label: "Genetic Screening" },
  { to: "/fertility-enhancing-laparoscopy-and-hysteroscopy", label: "Laparoscopy" },
];

const socialLinks = [
  { href: "https://twitter.com/dr_ila_gupta", label: "Twitter", icon: <FaTwitter /> },
  { href: "https://www.instagram.com/Ilaguptaivf", label: "Instagram", icon: <FaInstagram /> },
  { href: "https://www.linkedin.com/company/ilaguptaivf", label: "LinkedIn", icon: <FaLinkedinIn /> },
  { href: "https://www.facebook.com/ivfallindia", label: "Facebook", icon: <FaFacebookF /> },
  { href: "https://www.youtube.com/channel/UCBWarjxEw2NFrKvZkyH-pdg", label: "YouTube", icon: <FaYoutube /> },
];

const Footer = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="footer-cta">
          <div className="footer-cta__text">
            <p className="footer-kicker">Begin your fertility journey</p>
            <h2>Speak with Dr. Ila Gupta about a personalised treatment plan.</h2>
          </div>
          <div className="footer-cta__actions">
            <a href="tel:+919205020856" className="footer-btn footer-btn--light">
              <FaPhoneAlt /> Call +91 92050 20856
            </a>
            <Link to="/appointment" className="footer-btn footer-btn--outline">
              Book a Consultation
            </Link>
          </div>
        </div>

        <div className="footer-top">
          <div className="footer-col footer-col--brand">
            <h3>Dr. Ila Gupta</h3>
            <p className="footer-role">
              Chairperson & Chief Consultant IVF, Pristyn Care Ferticity Delhi
              <br />
              Co-founder & Director, Ferticity Delhi
            </p>

            <ul className="footer-contact">
              <li>
                <FaMapMarkerAlt />
                <span>
                  12, Navjeevan Vihar, Geetanjali Enclave,
                  <br />
                  Malviya Nagar, New Delhi, Delhi 110017
                </span>
              </li>
              <li>
                <FaPhoneAlt />
                <a href="tel:+919205020856">+91 92050 20856</a>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:ilagupta.ivf@gmail.com">ilagupta.ivf@gmail.com</a>
              </li>
            </ul>

            <div className="footer-social">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h3>Quick Links</h3>
            <ul>
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h3>Our Services</h3>
            <ul>
              {servicesPrimary.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h3>Specialised Care</h3>
            <ul>
              {servicesSecondary.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-disclaimer">
          <p>
            Disclaimer: The content on this website is for awareness only.
            Please consult a professional IVF specialist.
          </p>
        </div>

        <div className="footer-bottom">
          <p>
            © 2026 Digimarq. All Rights Reserved. | Designed & Deployed by{" "}
            <a
              href="https://www.digimarqtechnology.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Digimarq technology Pvt
            </a>
          </p>
        </div>
      </footer>

      <a
        href="https://wa.me/9205020856?text=Hello%20Doctor,%20I%20want%20to%20book%20a%20consultation"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>
    </>
  );
};

export default Footer;
